import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useBreakpoint } from '@moda/om';
import { ResponsiveImage } from '../../ResponsiveImage';

import './DesktopProductMediaGalleryImageThumb.scss';

interface Props {
  src: string;
  alt: string;
  index: number;
  selected: boolean;
  onClick: (index: number) => void;
  onMouseEnter: (index: number) => void;
  onError?: () => void;
}

export const DesktopProductMediaGalleryImageThumb: React.FC<Props> = ({
  src,
  alt,
  index,
  selected,
  onClick,
  onMouseEnter,
  onError
}) => {
  const isMobile = useBreakpoint({ lt: 'md' }).matches;
  const handleClick = useCallback(() => onClick(index), [index, onClick]);
  const handleMouseEnter = useCallback(() => onMouseEnter(index), [index, onMouseEnter]);

  return (
    <button
      className={classNames('DesktopProductMediaGalleryImageThumb', {
        'DesktopProductMediaGalleryImageThumb--selected': selected
      })}
      onClick={handleClick}
      onMouseEnter={isMobile ? undefined : handleMouseEnter}
    >
      <ResponsiveImage
        src={src}
        alt={alt}
        srcMode="static"
        maxWidth={80}
        maxHeight={110}
        onError={onError}
      />
    </button>
  );
};
